import React, {useState, useEffect} from "react";
import {IoAddCircleOutline} from "react-icons/io5";
import ModalAddAdditionalSpecification from "../../components/inserts/ModalAddAdditionalSpecification";
import Select from "../../components/Select";
import {createItem, deleteItem} from "../../services/service";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import DeleteButton from "../../components/DeleteButton";
import FillingDataTable from "../../components/FillingDataTable";
import Pagination from "../../components/Pagination";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import ModalAddConnectionSpecification from "../../components/connection/ModalAddConnectionSpecification";
import TemDataTableInline from "../../components/TemDataTableInline";
import EditButton from "../../components/EditButton";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "color", sort: true
}, {
    name: "article", sort: true
}, {
    name: "product_name", sort: true
}, {
    name: "supplier_name", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = [
    "id",
    "color",
    "article",
    "productName",
    "supplierName",
    "actions",
];

const ConnectionTypeSpecification = ({
                                         connectionTypeId,
                                         setSpecificationRowId,
                                     }) => {
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [isEdit,setIsEdit] = useState(false);
    const [connectionSpecificationId,setConnectionSpecificationId] = useState(null)

    const fetchData = async () => {
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/specification/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: "", regex: true},
                filter: {connectionTypeId: connectionTypeId},
            }
        );
        if (response.success) {
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id,
                    color: item?.textureName,
                    article: item?.article,
                    productName: item.productName,
                    supplierName: item.supplierName,
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <EditButton onclick={()=>editHandler(item.id)}/>
                            <DeleteButton onclick={() => handleDelete(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        if (connectionTypeId) {
            fetchData();
        }
    }, [connectionTypeId, itemOffset, itemsPerPage, data.recordsTotal]);

    const handleClose = ()=> {
        setOpen(false);
        setIsEdit(false);
        setConnectionSpecificationId(null)
    }
    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const editHandler = (id) => {
        setIsEdit(true)
        setConnectionSpecificationId(id)
        setOpen(true)
    }
    const handleDelete = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/specification/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    };

    return (
        <>
            <ModalAddConnectionSpecification
                open={open}
                handleClose={handleClose}
                isEdit={isEdit}
                connectionTypeId={connectionTypeId}
                fetchData_={fetchData}
                id={connectionSpecificationId}
            />
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t(`table.connection.connection_type_specification`)}
                </h1>
            </div>
            <div className="flex items-center justify-between">
                <Select setItemsPerPage={setItemsPerPage} itemsPerPage={itemsPerPage}/>
                <button
                    className={`${
                        connectionTypeId
                            ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
                    }   `}
                    onClick={() => setOpen(true)}
                    disabled={connectionTypeId ? false : true}
                >
                    {t('action.add')} {connectionTypeId}
                    <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                </button>
            </div>
            <TemDataTableInline
                data={data.data}
                bodyContent={bodyTable}
                headerTable={headerTable}
                rowHandler={(id) => setSpecificationRowId(id)}
                sortFunction={sortFunction}
            />
            <Pagination
                handlePageClick={handlePageClick}
                pageCount={data.pageCount}
                forcePage={forcePage}
            />
        </>
    );
};

export default ConnectionTypeSpecification;
